{
  "body_preview": "Hey — should we move some of the savings into the I-Bond ladder this quarter? We've been letting it sit in HYSA at 4.5% and the I-Bond fixed rate is starting to look attractive again.",
  "messages_url": "https://dev.hearthfire.ai/messages",
  "sender_display_name": "Christianna",
  "sent_at_human": "May 9, 2026 at 8:42 PM",
  "thread_title": "Banking & cash strategy"
}
